import React from "react";
import {sendToUnity} from "./UnityLoader"



export class ActionButton extends React.Component {
    render() {
        return (
            <div>
                <button onClick={() => {console.log("clicked"); sendToUnity.sendPackage(); }} >Talk To Unity</button>
            </div>
        );
    }
}

export default ActionButton;